const fr = {
  'home.eyebrow':         '🌍 geoplay24.com',
  'home.title':           'Geo Play 24',
  'home.subtitle.line1':  '7 jeux de géographie immersifs.',
  'home.subtitle.line2':  '1 Monde. 5 Niveaux. Émerveillement infini.',
  'home.tagline.line1':   'Sept jeux, une planète.',
  'home.tagline.line2':   'Découvre chaque coin de la Terre — rivalise, gagne des points, conquiers ton empire.',
  'home.footer.company':  'Société',
  'home.footer.legal':    'Mentions légales',
  'home.footer.about':    'À propos',
  'home.footer.contact':  'Contact',
  'home.footer.github':   'GitHub',
  'home.footer.tiktok':   'TikTok',
  'home.footer.x':        'X / Twitter',
  'home.footer.privacy':  'Confidentialité',
  'home.footer.terms':    'Conditions',
  'home.footer.cookies':  'Cookies',
  'home.copy':            'powered by: © 2026 Janek @ DevFlow C ™️',
  'home.beta.title':      'Rejoins les testeurs précoces de notre app Android',
  'home.beta.text':       'Reçois un badge Founder, Premium à vie, et une chance de gagner les prix tirés au sort ci-dessus.',
  'home.beta.cta':        'Programme BÊTA',

  'common.start':         'Démarrer',
  'common.startBig':      '▶ Démarrer',
  'common.back':          'Retour',
  'common.home':          'Accueil',
  'common.howToPlay':     'Comment jouer',
  'common.gotIt':         'Compris — retour au jeu',
  'common.next':          'Suivant',
  'common.restart':       'Recommencer',
  'common.tryAgain':      'Réessayer',
  'common.playAgain':     'Rejouer',
  'common.mainMenu':      'Menu principal',
  'common.quit':          'Quitter',
  'common.play':          'Jouer',
  'common.unlock':        '🔒 Débloquer avec Premium',
  'common.language':      'Langue',

  'rules.kicker.goal':         'Objectif',
  'rules.kicker.howToPlay':    'Comment jouer',
  'rules.kicker.levels':       'Niveaux',
  'rules.kicker.tips':         'Astuces',
  'rules.gameNotFound':        'Jeu introuvable',
  'rules.points':              'pts',

  'games.origin.title':       'Origin Hunt',
  'games.origin.tagline':     'Trouve tes racines',
  'games.origin.description': 'Un lieu Street View aléatoire dans le monde. Pose-toi sur la carte. Précision de 100 km → 1 km sur 5 niveaux.',
  'games.hunt.title':         'Object Hunt',
  'games.hunt.tagline':       'Chasse au trésor GPS',
  'games.hunt.description':   'Lâché près d\'un monument réel. Marche dans Street View pour le trouver. La boussole devient de moins en moins utile.',
  'games.photo.title':        'Photo Detective',
  'games.photo.tagline':      'Lis les indices',
  'games.photo.description':  'Un seul cliché Street View — pas de panoramique, pas de mouvement. Lis les panneaux, plantes, direction du soleil. De 30 sec à un éclair de 5 sec.',
  'games.pangaea.title':      'Pangaea Puzzle',
  'games.pangaea.tagline':    'Reconstitue la Terre',
  'games.pangaea.description':'Continents et îles flottent autour d\'un globe 3D. Glisse-les à leur place — position actuelle ou ancienne Pangée.',

  'rules.origin.goal': 'Tu es déposé dans un Street View aléatoire. Pointe-toi sur la carte du monde aussi précisément que possible.',
  'rules.origin.step1': 'Regarde autour. Lis les panneaux, compte les voies, observe la position du soleil.',
  'rules.origin.step2': 'Clique sur la mini-carte pour poser une épingle.',
  'rules.origin.step3': 'Valide. Plus l\'épingle est proche, plus de points.',
  'rules.origin.step4': 'Les niveaux s\'enchaînent — passe le seuil de distance pour débloquer le suivant.',
  'rules.origin.level1': 'à 100 km',
  'rules.origin.level2': 'à 50 km',
  'rules.origin.level3': 'à 25 km',
  'rules.origin.level4': 'à 10 km',
  'rules.origin.level5': 'à 1 km',
  'rules.origin.tip1': 'Sens de circulation, format de plaque et couleur du marquage trahissent vite le pays.',
  'rules.origin.tip2': 'Végétation + hauteur du soleil restreignent la latitude. Les panneaux de rue fixent la ville.',
  'rules.origin.tip3': 'Le Master Geographer (N5 = 1 km) est brutal — la plupart des runs s\'arrêtent à N3 ou N4.',

  'rules.hunt.goal': 'Tu es placé en Street View près d\'un vrai monument. Marche jusqu\'à être dessus. La boussole devient moins utile à chaque niveau.',
  'rules.hunt.step1': 'Lis le nom de la cible en haut.',
  'rules.hunt.step2': 'Utilise la flèche + distance pour t\'orienter.',
  'rules.hunt.step3': 'Clique sur les chevrons pour avancer dans Street View.',
  'rules.hunt.step4': 'Dans la zone de validation, le bouton « Trouvé ! » s\'active — appuie pour marquer.',
  'rules.hunt.level1': '5 km · 10 min · célébrité mondiale · flèche + distance exacte · zone 100 m',
  'rules.hunt.level2': '15 km · 12 min · célébrité mondiale · flèche + distance arrondie',
  'rules.hunt.level3': '25 km · 12 min · connu nationalement · boussole seulement',
  'rules.hunt.level4': '50 km · 15 min · connu nationalement · indice chaud/froid',
  'rules.hunt.level5': '50 km · 10 min · obscur · seulement le nom, pas de GPS',
  'rules.hunt.tip1': 'En N4–N5 tu as 3 Compass Pings — éclats de flèche, à utiliser avec parcimonie.',
  'rules.hunt.tip2': 'Bonus mi-parcours : passer la moitié donne +2 minutes.',
  'rules.hunt.tip3': 'Avec seulement le nom, fouille ta mémoire ou observe les alentours — beaucoup de monuments sont reconnaissables de loin.',

  'rules.photo.goal': 'Tu vois un cliché Street View statique — pas de panoramique, pas de mouvement. À partir des panneaux, plantes, soleil et marquages, déduis le lieu.',
  'rules.photo.step1': 'Choisis d\'abord une région (Monde, Europe, Asie…) — ça fixe la botte de foin.',
  'rules.photo.step2': 'La photo apparaît un temps limité. Profite de chaque seconde.',
  'rules.photo.step3': 'À la fin du timer, une carte apparaît. Pose ton meilleur pari.',
  'rules.photo.step4': 'Plus proche = plus de points. L\'écran de résultat rejoue la photo pour voir ce que tu as raté.',
  'rules.photo.level1': '30 sec d\'observation · précision 1 000 km',
  'rules.photo.level2': '20 sec · 500 km',
  'rules.photo.level3': '15 sec · 250 km',
  'rules.photo.level4': '10 sec · 100 km',
  'rules.photo.level5': 'éclair de 5 sec · 50 km',
  'rules.photo.tip1': 'La langue des panneaux est l\'indice le plus rapide. Un seul mot suffit souvent.',
  'rules.photo.tip2': 'La direction du soleil indique le sud (hémisphère nord) ou le nord (hémisphère sud).',
  'rules.photo.tip3': 'Forme des poteaux, marquages au sol et plaques d\'immatriculation sont étonnamment révélateurs.',

  'rules.pangaea.goal': 'Une Terre 3D, six continents. Place chacun dans la tolérance angulaire du niveau — position actuelle ou il y a 300 millions d\'années (Pangée).',
  'rules.pangaea.step1': 'Choisis un continent dans la liste de droite.',
  'rules.pangaea.step2': 'Clique sur le globe à l\'endroit où il va.',
  'rules.pangaea.step3': 'Dans la tolérance → s\'aimante. Sinon → retour rouge, réessaie.',
  'rules.pangaea.step4': '3 essais par continent. Place au moins 5 sur 6 pour avancer.',
  'rules.pangaea.level1': 'Continents · aujourd\'hui · tolérance 25°',
  'rules.pangaea.level2': 'aujourd\'hui · tolérance 18°',
  'rules.pangaea.level3': 'aujourd\'hui · 12° précis',
  'rules.pangaea.level4': 'Pangée · ancien · tolérance 25°',
  'rules.pangaea.level5': 'Pangée · ancien · 18° précis',
  'rules.pangaea.tip1': 'Glisse le globe pour tourner. Molette pour zoomer.',
  'rules.pangaea.tip2': 'En Pangée, les continents étaient regroupés au sud — Afrique et Amérique du Sud emboîtées, Inde contre l\'Afrique de l\'Est, Amérique du Nord collée à l\'Europe.',
  'rules.pangaea.tip3': 'L\'Antarctique se trouvait à peu près à l\'équateur. L\'Australie s\'y accrochait par-dessous.',

  /* ─── Landmark Quiz ─── */
  'games.landmark.title':          'Landmark Quiz',
  'games.landmark.tagline':        'Reconnais le monument',
  'games.landmark.description':    'Une photo d\'un bâtiment ou monument célèbre — reconnais-le et place une épingle sur la carte du monde.',
  'rules.landmark.goal':           'Tu vois la photo d\'un monument célèbre. Place une épingle sur la carte du monde où tu penses qu\'il se trouve.',
  'rules.landmark.step1':          'Regarde la photo quelques secondes. Reconnais le bâtiment, lis le contexte.',
  'rules.landmark.step2':          'À la fin du timer, la carte du monde apparaît.',
  'rules.landmark.step3':          'Pose une épingle et valide. Plus c\'est près, plus tu marques.',
  'rules.landmark.step4':          'Cinq niveaux. Chacun plus court et plus serré que le précédent.',
  'rules.landmark.level1':         '30 sec d\'observation · précision 1 000 km',
  'rules.landmark.level2':         '20 sec · 500 km',
  'rules.landmark.level3':         '15 sec · 250 km',
  'rules.landmark.level4':         '10 sec · 100 km',
  'rules.landmark.level5':         'éclair de 5 sec · 50 km',
  'rules.landmark.tip1':           'Les formes emblématiques (Eiffel, pyramides) se reconnaissent instantanément — les points viennent du placement précis.',
  'rules.landmark.tip2':           'Monuments moins connus : lis le contexte — climat, architecture, environnement.',
  'rules.landmark.tip3':           'Photos issues de Wikipédia sous licence CC-BY-SA. Touche le crédit pour voir la source.',

  'paywall.title':        "Ce jeu est Premium",
  'paywall.text':         "Débloque ce jeu avec les points que tu gagnes en jouant.",
  'paywall.cta':          "Rejoindre le programme BETA",
  'paywall.dismiss':      "Plus tard peut-être",

  /* ─── Spot the Landmark ─── */
  'games.spot.title':       "Spot the Landmark",
  'games.spot.tagline':     "Choix multiple",
  'games.spot.description': "Photo d'un bâtiment ou monument célèbre — choisis la bonne réponse parmi 3-6 options. Mode infini, plus dur à chaque tour.",

  'rules.spot.goal':   "Regarde la photo, choisis le bon monument. Une mauvaise réponse termine la partie.",
  'rules.spot.step1':  "Choisis une région (Monde, Europe, Asie…) — la piscine est filtrée sur ce continent.",
  'rules.spot.step2':  "Une photo de monument célèbre apparaît avec une question.",
  'rules.spot.step3':  "Touche la bonne réponse parmi les options.",
  'rules.spot.step4':  "Garde la série en vie — chaque niveau ajoute un choix (max 6) et devient plus dur.",
  'rules.spot.level1': "N1–N3 · 3–5 choix · juste le nom",
  'rules.spot.level2': "N4+ · 6 choix · juste le nom",
  'rules.spot.level3': "N10+ · 6 choix · nom + pays",
  'rules.spot.level4': "N20+ · 6 choix · nom + ville + pays",
  'rules.spot.level5': "Infini · le score grandit avec la profondeur · une erreur arrête tout",
  'rules.spot.tip1':   "Les distracteurs viennent du même continent — lis bien.",
  'rules.spot.tip2':   "Les formes iconiques (Eiffel, pyramides) sont faciles — les points viennent de la profondeur.",
  'rules.spot.tip3':   "À partir du N10 on ajoute le pays; au N20 la ville.",

  "spot.region.title": "Où veux-tu jouer ?",
  "spot.region.sub": "Choisis une région. Des monuments célèbres apparaîtront — choisis la bonne réponse.",
  "spot.q.name": "Quel est ce monument ?",
  "spot.q.namecountry": "Nom + pays ?",
  "spot.q.namecity": "Nom + ville + pays ?",
  "spot.score": "Score",
  "spot.choices": "choix",
  "spot.correct": "CORRECT",
  "spot.wrong": "FAUX",
  "spot.points": "POINTS",
  "spot.runTotal": "Total partie",
  "spot.next": "Suivant →",
  "spot.youPicked": "Tu as choisi",
  "spot.finalScore": "SCORE FINAL",
  "spot.reachedLevel": "Tu as atteint le niveau",
  "spot.tryAgain": "Recommencer ↺",
  "spot.changeRegion": "Changer de région",
  "spot.mainMenu": "Menu principal",

  /* ─── Auth ─── */
  "auth.signIn": "Connexion",
  "auth.eyebrow": "MINDFUL ZEN WORLD",
  "auth.title": "Connexion ou créer un compte",
  "auth.subtitle": "Pas de mot de passe — on t'envoie un lien magique par email. Nouveau ? Compte créé automatiquement.",
  "auth.send": "Envoyer le lien",
  "auth.sending": "Envoi…",
  "auth.invalidEmail": "Entre un email valide s'il te plaît.",
  "auth.sendFailed": "Impossible d'envoyer le lien. Réessaie.",
  "auth.checkInbox": "Vérifie ta boîte mail",
  "auth.linkSentTo": "Un lien de connexion est en route vers",
  "auth.spamHint": "Pas reçu ? Regarde dans les spams. Le lien expire dans 1 heure.",
  "auth.gotIt": "Compris",
  "auth.fineprint": "En continuant tu acceptes nos CGU et notre Politique de confidentialité.",
  "auth.menu.profile": "Mon profil",
  "auth.menu.admin": "Admin",
  "auth.menu.signOut": "Déconnexion",
  "auth.callback.signingIn": "Connexion en cours…",
  "auth.callback.hold": "Une seconde.",
  "auth.callback.welcome": "Bienvenue",
  "auth.callback.redirecting": "On te ramène aux jeux…",
  "auth.callback.problem": "Une erreur s'est produite",

  /* ─── Auth ─── */

  /* ─── Profile ─── */
  "profile.title": "Mon Profil",
  "profile.totalPoints": "Points totaux",
  "profile.totalRuns": "Parties jouées",
  "profile.gamesPlayed": "Jeux essayés",
  "profile.editTitle": "Modifier le profil",
  "profile.displayName": "Nom affiché",
  "profile.avatar": "Avatar",
  "profile.country": "Pays (facultatif)",
  "profile.countryHint": "Code ISO à 2 lettres, ex. FR, US, JP. Pour les drapeaux du classement.",
  "profile.save": "Enregistrer",
  "profile.saving": "Enregistrement…",
  "profile.saved": "Enregistré",
  "profile.nameTooShort": "Le nom affiché doit faire au moins 2 caractères.",
  "profile.perGame": "Meilleur par jeu",
  "profile.noRuns": "Aucune partie jouée — retourne au menu et choisis un jeu.",

  /* ─── Profile ─── */

  /* ─── Gating + Anon limit ─── */
  "common.locked": "VERROUILLÉ",
  "common.needPoints": "{n} PTS REQUIS",
  "locked.pill": "VERROUILLÉ",
  "locked.title": "{game} est verrouillé",
  "locked.text": "Encore {remaining} points pour débloquer {game}. Continue à jouer aux jeux disponibles.",
  "locked.dismiss": "OK",
  "spot.anon.playsLeft": "{n} parties gratuites restantes — connecte-toi pour continuer.",
  "spot.anon.title": "Tu as utilisé tes parties gratuites",
  "spot.anon.text": "Tu as joué {used} parties sur {limit} gratuites. Connecte-toi pour continuer — gratuit, sans mot de passe, juste un lien magique par email.",
  "spot.anon.signIn": "Se connecter →",
  "spot.anon.back": "Retour au menu",

  /* ─── Gating + Anon limit ─── */

  /* ─── Next game banner ─── */
  "rules.next.upcoming": "PROCHAINEMENT",
  "rules.next.unlocked": "PROCHAIN — DÉBLOQUÉ",
  "rules.next.unlockedHint": "Tu as assez de points — retour au menu et joue.",
  "rules.next.needMore": "{remaining} pts pour débloquer — continue à jouer.",
  "rules.next.signedOut": "Gagne {threshold} points pour débloquer — connecte-toi pour les compter.",
  "rules.next.premiumHint": "Débloqué avec Premium — bientôt avec la bêta Android.",

  /* ─── Next game banner ─── */

  /* ─── Audio Atlas ─── */
  'games.audio.title':       "Audio Atlas",
  'games.audio.tagline':     "Drapeau + hymne",
  'games.audio.description': "Un hymne national joue, le drapeau du pays s\'affiche. Place un pin sur la capitale.",

  'rules.audio.goal':   "Tu entends un hymne national et vois le drapeau du pays. Place un pin sur la capitale — aussi précisément que possible.",
  'rules.audio.step1':  "Choisis une région. La piscine se limite au continent.",
  'rules.audio.step2':  "L'hymne démarre automatiquement. Le drapeau reste affiché tout du long.",
  'rules.audio.step3':  "Au timer zéro, la carte apparaît. Place ton pin sur la capitale.",
  'rules.audio.step4':  "Pour passer un niveau, place le pin dans la limite de distance. Niveau plus haut = écoute plus courte.",
  'rules.audio.level1': "10 sec écoute · ≤ 1 000 km",
  'rules.audio.level2': "8 sec · 500 km",
  'rules.audio.level3': "6 sec · 250 km",
  'rules.audio.level4': "4 sec · 100 km",
  'rules.audio.level5': "Flash 3 sec · 50 km",
  'rules.audio.tip1':   "La langue est l'indice le plus rapide — un mot suffit souvent.",
  'rules.audio.tip2':   "Certaines capitales ne sont pas la plus grande ville (Brasília, Canberra, Ottawa, Pretoria).",
  'rules.audio.tip3':   "Le tempo et l\'instrumentation de l\'hymne aident si le drapeau est inconnu.",

  "audio.region.title": "Où veux-tu écouter ?",
  "audio.region.sub": "Choisis une région. Tu entendras un hymne national et verras le drapeau du pays — place un pin sur la capitale.",
  "audio.empty.title": "Aucun extrait audio pour l'instant",
  "audio.empty.text": "Aucun hymne disponible pour l'instant — la sélection est en cours de curation. Reviens bientôt pour identifier de nouveaux pays.",
  "audio.listen.hint": "Tu reconnais le drapeau et l\'hymne ? Place le pin sur la capitale.",
  "audio.listen.skip": "J'en sais assez →",
  "audio.submit.ready": "Soumettre →",
  "audio.submit.empty": "Clique sur la carte pour poser un pin",
  "audio.changeRegion": "Changer de région",

  /* ─── Empire ─── */
  "profile.empire.title": "Mon Empire",
  "profile.empire.empty": "Identifie un pays dans Audio Atlas ou Landmark Quiz pour le réclamer. Ton empire grandit à chaque bonne réponse.",

  /* ─── Empire ─── */

  /* ─── Boost / Shop ─── */
  "boost.title": "Évite le grind",
  "boost.tagline": "Achète des points, débloque plus vite",
  "boost.description": "Pas envie d'attendre ? Trois packs à partir de €2.99. Les points arrivent instantanément et comptent pour chaque déblocage.",
  "boost.cta": "Acheter des points",
  "shop.title": "Boutique de points",
  "shop.sub": "Évite le grind",
  "shop.buy": "Acheter",
  "shop.opening": "Ouverture…",
  "shop.success": "Paiement confirmé — points crédités en quelques secondes.",
  "shop.cancel": "Paiement annulé — aucune somme prélevée.",
  "shop.fineprint": "Achat unique via Stripe. Les points arrivent après confirmation. Pas d'abonnement, pas de reconduction.",
  "shop.boost.badge": "Populaire",
  "shop.power.badge": "Meilleur rapport",

  /* ─── Boost / Shop ─── */
};

export default fr;
